var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"result-text theme-title transparent",class:_vm.team.component.position ==='appBar' ? 'appbar-result-action': 'main-result',attrs:{"tile":"","flat":""}},[_vm._v(" "+_vm._s(_vm.score ? _vm.score : 0)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }